var map = {
	"./animal.svg": 459,
	"./arrow.svg": 460,
	"./bicycle.svg": 461,
	"./boat.svg": 462,
	"./bus.svg": 463,
	"./car.svg": 464,
	"./crane.svg": 465,
	"./default.svg": 466,
	"./helicopter.svg": 467,
	"./motorcycle.svg": 468,
	"./offroad.svg": 469,
	"./person.svg": 470,
	"./pickup.svg": 471,
	"./plane.svg": 472,
	"./ship.svg": 473,
	"./tractor.svg": 474,
	"./train.svg": 475,
	"./tram.svg": 476,
	"./trolleybus.svg": 477,
	"./truck.svg": 478,
	"./van.svg": 479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1173;